<template>
  <div class="employee-summary">
    <div class="employee-summary__avatar">
      <img :src="avatarUrl" :alt="employee.fullName">
    </div>
    <div class="employee-summary__content">
      <div class="employee-summary__name">{{ employee.fullName }}</div>
      <div class="employee-summary__subtitle">{{ subtitle }}</div>
    </div>
  </div>
</template>

<script>
import { employeeSubtitle } from './employeeData'

export default {
  name: 'EmployeeSummary',
  props: {
    employee: {
      type: Object,
      required: true,
    },
  },
  computed: {
    avatarUrl() {
      return this.employee.photoUrl || require('@/assets/img/temp/avatar-slug.jpg')
    },
    subtitle() {
      return employeeSubtitle(this.employee)
    },
  },
}
</script>

<style lang="sass" scoped>
.employee-summary
  display: flex
  align-items: center
  gap: 16px
  padding: 20px
  border: 1px solid #e5e5e5
  border-radius: 14px

.employee-summary__avatar
  flex: 0 0 64px
  display: flex
  align-items: center
  justify-content: center
  width: 64px
  height: 64px
  overflow: hidden
  border-radius: 50%
  background-color: $color-theme
  color: #fff
  font-size: 20px
  font-weight: 600

  img
    width: 100%
    height: 100%
    object-fit: cover

.employee-summary__content
  min-width: 0

.employee-summary__name
  margin-bottom: 5px
  color: #1f1f1f
  font-size: 21px
  font-weight: 600
  line-height: 1.2

.employee-summary__subtitle
  color: #707070
  font-size: 15px
  line-height: 1.4
</style>
